// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Report_wrapper__1eBf4"};